import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Container, Button, Form, FormGroup , Input } from 'reactstrap';
import { ChangePasswordtUser } from '../../actions/userActions';

class ChangePassword extends Component {
  constructor(props) {
    super(props);

    this.emailRecipient = new URLSearchParams(this.props.location.search).get('email');
  }


  handleSubmit = async (e) => {
    e.preventDefault();
    
    let { ChangePasswordtUser } = this.props
    let data = new FormData(document.querySelector('#change-password-form'));
    ChangePasswordtUser(data); 
    
  };

  render() {
    let {login} = this.props.userState;
    return (
      <div>
        <Container>
            <Form onSubmit={this.handleSubmit} id="change-password-form" className="mx-auto">
                {login && login.check === 1 ? 
                    <div className="alert alert-success" role="alert">Mise à jour de mot de passe avec success!</div>
                    :null
                }
                {login && login.check === 2 ? 
                        <div className="alert alert-danger" role="alert">Réinitialiser de mot de passe est suspendue!</div>
                        : null
                }
                <h4>Changer votre mot de passe</h4>
                
                <FormGroup>
                    <Input type="password" name="newPassword" id="newPassword" required />
                    <Input type="hidden" name="email" id="email" defaultValue={this.emailRecipient ? this.emailRecipient : ''} />
                </FormGroup>
                <FormGroup>
                    <Button type="submit" color="primary">
                    Changer le mot de passe
                    </Button>
                </FormGroup>
            </Form>
            
        </Container>
      </div>
    );
  }
}

const mapStateToProps = ({ userReducer }) => ({
  userState: userReducer,
});

const mapDispatchToProps = (dispatch) => ({
  ChangePasswordtUser: bindActionCreators(ChangePasswordtUser, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(ChangePassword);



// WEBPACK FOOTER //
// ./src/containers/User/ChangePassword.js